import { Router } from 'expo-router';

import { routes } from 'utils/routing';

/**
 * Leaves an offer detail modal for the offers tab.
 *
 * Cold and in-app offer deeplinks already have `(tabs)` under the modal, so a
 * plain dismiss reveals the tab underneath (often Menu) instead of Offers.
 * `dismissTo` targets the offers tab, then `replace` focuses it even when the
 * store snapshot reports that the stack cannot dismiss.
 *
 * This must not pass `unavailableItemId`. That param pins the offer as
 * unavailable and can reopen it from the feed.
 */
export function navigateToOffers(
  router: Pick<Router, 'canDismiss' | 'dismissTo' | 'replace'>
): void {
  const route = {
    pathname: routes.offers as '/offers',
  };

  if (router.canDismiss()) {
    router.dismissTo(route);
  }

  router.replace(route);
}
